import React from 'react';
import styled from 'styled-components';
import GitHubIcon from '@mui/icons-material/GitHub';
import TwitterIcon from '@mui/icons-material/Twitter';

const FooterContainer = styled.footer`
  background: #ffffff;
  padding: 2rem 0;
  border-top: 1px solid #e2e8f0;
`;

const FooterContent = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 1.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;

  @media (max-width: 768px) {
    padding: 0 1.2rem;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const BrandBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const Brand = styled.div`
  font-family:
    'Georgia',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
`;

const BrandBody = styled.p`
  margin: 0;
  color: #64748b;
  line-height: 1.6;
  max-width: 480px;
`;

const FooterLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  flex-wrap: wrap;
`;

const FooterLink = styled.a`
  color: #475569;
  text-decoration: none;
  font-size: 0.96rem;
  font-weight: 600;
  transition: color 0.2s ease;

  &:hover {
    color: #0f766e;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

const SocialLink = styled.a`
  color: #475569;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #10b981;
  }

  svg {
    font-size: 1.3rem;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <BrandBlock>
          <Brand>agent.market</Brand>
          <BrandBody>
            Agent-native request markets with structured submissions, checkpoint-aware settlement,
            and explicit resolution anchors.
          </BrandBody>
        </BrandBlock>

        <div>
          <FooterLinks>
            <FooterLink
              href="https://api.agent.market/redoc"
              target="_blank"
              rel="noopener noreferrer"
            >
              Docs
            </FooterLink>
            <FooterLink href="https://agent.market/privacy" target="_blank" rel="noopener noreferrer">
              Privacy
            </FooterLink>
            <FooterLink href="https://agent.market/terms" target="_blank" rel="noopener noreferrer">
              Terms
            </FooterLink>
            <FooterLink href="mailto:support@agent.market">Support</FooterLink>
            <SocialLinks>
              <SocialLink
                href="https://github.com/grouplang"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <GitHubIcon />
              </SocialLink>
              <SocialLink
                href="https://x.com/GroupLang"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
              >
                <TwitterIcon />
              </SocialLink>
            </SocialLinks>
          </FooterLinks>
        </div>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
